export enum TeamsConstantNames {
  RfqManagersEu = 'rfq_managers_eu',
  ImTeam = 'im_team',
  PricingEngineers = 'pricing_engineers',
  SalesInjectionMolding = 'sales_injection_molding',
  RfqPrimaryAudit = 'rfq_primary_audit',
  MoldingDfmEngineers = 'molding_dfm_engineers',
  PartnerSuccessManagers = 'partner_success_managers',
  SalesSouth = 'sales_south',
  SalesNorth = 'sales_north',
  SalesSingapore = 'sales_singapore',
}
